import { omitNullish } from '@/shared/utils/omit-nullish';

export const UTM_SEARCH_PARAM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const;

export type UtmSearchParamKey = (typeof UTM_SEARCH_PARAM_KEYS)[number];

export type UtmParams = Partial<Record<UtmSearchParamKey, string>>;

function getSearchParamString(value: unknown): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }

  const trimmedValue = value.trim();
  return trimmedValue.length > 0 ? trimmedValue : undefined;
}

export function extractUtmParams(search: Record<string, unknown>): UtmParams | undefined {
  const utm = omitNullish({
    utm_campaign: getSearchParamString(search.utm_campaign),
    utm_content: getSearchParamString(search.utm_content),
    utm_medium: getSearchParamString(search.utm_medium),
    utm_source: getSearchParamString(search.utm_source),
    utm_term: getSearchParamString(search.utm_term),
  }) as UtmParams;

  return Object.keys(utm).length > 0 ? utm : undefined;
}
